<nav class="navbar navbar-expand-md sticky-top main-nav">
  <div class="logo-group mb-1 mr-3" routerLink="/">
    <img
      routerLink="/"
      src="/assets/images/smart-menu-logo.svg"
      alt="back"
      class="pointer"
      alt="R.Manager"
    />
  </div>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <i class="fa fa-bars text-light navbar-toggler-icon"></i>
  </button>

  <div
    class="collapse navbar-collapse align-items-center justify-content-between"
    id="navbarSupportedContent"
  >
    <ul class="navbar-nav mt-2 mt-lg-0">
      <li class="nav-item">
        <a
          routerLinkActive="active"
          [routerLinkActiveOptions]="exact"
          routerLink="/"
          class="nav-link pointer"
        >
          Dashboard
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLinkActive="active"
          routerLink="/assignments"
          class="nav-link pointer"
          [routerLinkActiveOptions]="exact"
        >
          Table assignments
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLinkActive="active"
          routerLink="/accounts"
          class="nav-link pointer"
          [routerLinkActiveOptions]="exact"
        >
          Accounts
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLinkActive="active"
          routerLink="/orders"
          class="nav-link pointer"
          [routerLinkActiveOptions]="exact"
        >
          Orders
        </a>
      </li>
      <li class="nav-item">
        <a
          routerLinkActive="active"
          routerLink="/tables"
          class="nav-link pointer"
          [routerLinkActiveOptions]="exact"
        >
          Tables
        </a>
      </li>
    </ul>

    <div class="navbar-nav">
      <div
        class="d-flex flex-md-row flex-column align-items-md-center align-items-start ml-md-0 ml-3"
      >
        <div class="mt-md-0 mt-3 d-flex align-items-center mr-32 pointer">
          <div class="mr-4 dropdown position-relative">
            <img
              role="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              src="/assets/images/notif-bell.svg"
              alt="notifications"
              class="relative"
              width="42px"
              height="42px"
            />
            <span class="badge badge-secondary f-12 badge-pill">
              {{ unreadCount }}
            </span>
            <div
              class="dropdown-menu"
              id="notifications-dropdown"
              aria-labelledby="dropdownMenuButton"
            >
              <div class="notifocations-header border-bottom">
                <div
                  class="p-3 d-flex justify-content-between align-items-cente"
                >
                  <h5 class="f-18 text__grey-700 lh-28 fw-600">
                    Notifications
                  </h5>
                  <a
                    class="text__brand fw-600 f-14 lh-20 mark-as-read"
                    (click)="markNotificationAsRead('all')"
                    >Mark all as read</a
                  >
                </div>
              </div>

              <div class="notifications-body px-4 pb-5 pt-4">
                <div *ngIf="notifications && notifications.length > 0">
                  <ng-container *ngFor="let item of notifications">
                    <div
                      class="card card-body pb-1"
                      [ngClass]="{ 'is-read': !item.isRead }"
                    >
                      <p class="f-14 fw-600 lh-20 text__grey-700">
                        {{ item?.title }}
                      </p>
                      <p class="text__grey-500 fw-400 lh-20 f-14">
                        {{ item?.body }}
                      </p>

                      <div
                        class="mt-2 d-flex justify-content-between align-items-center"
                      >
                        <p class="text__grey-500 f-12">
                          {{ item.creatAt | dateAgo }}
                        </p>
                        <p
                          *ngIf="!item?.isRead"
                          class="text__brand fw-600 f-14 lh-20 pointer mark-as-read"
                          (click)="markNotificationAsRead('single', item)"
                        >
                          Mark as read
                        </p>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div *ngIf="notifications && notifications.length === 0">
                  <div class="text-center mt-5">
                    <p class="text__brand f-18 text-center lh-20">
                      No notifications at the moment!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section class="mr-2 d-flex align-items-end">
            <app-base-name-avatar
              *ngIf="!credentials()?.pictureUrl"
              [name]="credentials()?.name"
              [size]="'small'"
            ></app-base-name-avatar>
            <img
              *ngIf="credentials()?.pictureUrl"
              [src]="credentials()?.pictureUrl"
              class="profile-img"
              alt=""
            />
            &nbsp;
          </section>
          <div class="d-flex flex-column">
            <h5
              *ngIf="credentials()?.name"
              class="f-14 mb-0 fw-600 text__grey-50 text-capitalize"
            >
              {{ credentials()?.name }}
            </h5>
            <p class="mb-0 fw-600 text__grey-200 text-lowercase f-14">
              {{ credentials()?.email }}
            </p>
            <p class="mb-0 fw-400 text__grey-200 text-capitalize f-14 mb-0">
              {{ credentials()?.restaurant?.name }}
            </p>
          </div>
          <img
            class=""
            [matMenuTriggerFor]="beforeMenu"
            src="/assets/icons/dropdown-icon.svg"
            alt="v"
          />
          <mat-menu #beforeMenu="matMenu">
            <button mat-menu-item class="border-bottom" (click)="editProfile()">
              <img src="/assets/icons/edit-icon.svg" alt="" />
              <span class="text__gray-700 f-14 ml-3 pr-5"> Edit Profile </span>
            </button>
            <button mat-menu-item (click)="logout()">
              <img src="/assets/icons/logout.svg" alt="" />
              <span class="text__error-600 f-14 ml-21 pr-5">Log out</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
</nav>
